export function affiliatedBusinessDisclosureColdwellBanker2026() {
return [   //2024 Release 2026-01-10 09:53:53
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Client Names Legal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 10,
   top: 39.6,
   left: 108,
   width: 355.32,
   height: 9.24
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 111.96,
   left: 108,
   width: 355.32,
   height: 9.24
}
] }
